import pdfFonts from "pdfmake/build/vfs_fonts.js";
import pdfMake from "pdfmake/build/pdfmake.js";

const fontsConfig = {
  "THSarabunNew": {
    "normal": "THSarabunNew.ttf",
    "bold": "THSarabunNew-Bold.ttf",
    "italics": "THSarabunNew-Italic.ttf",
    "bolditalics": "THSarabunNew-BoldItalic.ttf"
  },
  "Roboto": {
    "normal": "Roboto-Regular.ttf",
    "bold": "Roboto-Bold.ttf",
    "italics": "Roboto-Italic.ttf",
    "bolditalics": "Roboto-BoldItalic.ttf"
  },
  "Taviraj": {
    "normal": "Taviraj-Regular.ttf",
    "bold": "Taviraj-Bold.ttf",
    "italics": "Taviraj-Italic.ttf",
    "bolditalics": "Taviraj-BoldItalic.ttf"
  },
  "Montserrat": {
    "normal": "Montserrat-Regular.ttf",
    "bold": "Montserrat-Bold.ttf",
    "italics": "Montserrat-Italic.ttf",
    "bolditalics": "Montserrat-BoldItalic.ttf"
  },
  "CenturyGothic": {
    "normal": "CenturyGothic.ttf",
    "bold": "CenturyGothicBold.TTF",
    "italics": "CenturyGothicItalic.TTF",
    "bolditalics": "CenturyGothicBoldItalic.TTF"
  },
  "Calibri": {
    "normal": "Calibri.ttf",
    "bold": "CalibriBold.TTF",
    "italics": "CalibriItalic.ttf",
    "bolditalics": "CalibriBoldItalic.ttf"
  },
  "Trirong": {
    "normal": "Trirong-Regular.ttf",
    "bold": "Trirong-SemiBold.ttf",
    "italics": "Trirong-Italic.ttf",
    "bolditalics": "Trirong-SemiBoldItalic.ttf"
  },
  "OpenSans": {
    "normal": "OpenSans-Regular.ttf",
    "bold": "OpenSans-SemiBold.ttf",
    "italics": "OpenSans-Italic.ttf",
    "bolditalics": "OpenSans-SemiBoldItalic.ttf"
  }
};

pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfMake.vfs;
pdfMake.fonts = fontsConfig;

export const getDocDefinition = ({ content=[], styles={} }) => ({
	pageSize: 'A4',
  pageMargins: [30, 30, 30, 30],
	content,
	styles: {
    'html-img': {
      margin: [14, 14, 14, 14],
      alignment: 'center',
    },
    'html-h1': {
      color: "#000",
      margin: [0, 0, 0, 2]
    },
    'html-h2': {
      color: "#000",
      margin: [0, 0, 0, 2]
    },
    'html-h3': {
      color: "#000",
      margin: [0, 0, 0, 2]
    },
    'html-h4': {
      color: "#000",
      margin: [0, 0, 0, 2]
    },
    'html-h5': {
      color: "#000",
      margin: [0, 0, 0, 2]
    },
    'html-h6': {
      color: "#000",
      margin: [0, 0, 0, 2]
    },
    'html-p': {
      margin: [0, 0, 0, 2]
    },
    'html-ul': {
      margin: 0
    },
    'html-ol': {
      margin: 0
    },
    'html-li': {
      margin: 0
    },
    ...styles
  },
	defaultStyle: {
    font: "OpenSans",
    fontSize: 10.3,
    lineHeight: 1,
    color: '#3a3a3a',
	},
});

export default pdfMake;